import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import "../../pages/AdminDashboard/Dashboard.css";
import { useTranslation } from "react-i18next";
import "../../Localization/i18n";

export default function VendorrequirementCard(props) {

  const { t } = useTranslation();
  const [Sete, setSate] = useState('');
  useEffect(() => {

    // if (props?.sections?.isMax == false) {
    //   for (let id = 0; id < props?.sections?.answers.length; id++) {
    //     if (props?.sections?.answers[id] <= props?.sections?.value) {
    //       setSate(1);
    //     }
    //     else {
    //       setSate(2);
    //     }
    //   }
    // }

    // if (props?.PQSTID == 8 || props?.PQSTID == 9 || props?.PQSTID == 13 || props?.PQSTID == 26 || props?.PQSTID == 31) {
    //   if (props?.sections?.isMax === true) {
    //     for (let id = 0; id < props?.sections?.answers.length; id++) {
    //       if (props?.sections?.answers[id] <= props?.sections?.value) {
    //         setSate(2);
    //       }
    //       else {
    //         setSate(1);
    //       }
    //     }
    //     // if (props?.sections?.answers[0] <= props?.sections?.value) {
    //     //   setSate(2);
    //     // }
    //     // else {
    //     //   setSate(1);
    //     // }

    //     // if (props?.sections?.answers[1] <= props?.sections?.value) {
    //     //   setSate(2);
    //     // }
    //     // else {
    //     //   setSate(1);
    //     // }

    //     // if (props?.sections?.answers[2] <= props?.sections?.value) {
    //     //   setSate(2);
    //     // }
    //     // else {
    //     //   setSate(1);
    //     // }

    //   }
    //   else {
    //     for (let id = 0; id < props?.sections?.answers.length; id++) {
    //       if (props?.sections?.answers[id] <= props?.sections?.value) {
    //         setSate(1);
    //       }
    //       else {
    //         setSate(2);
    //       }
    //     }

    //     // if (props?.sections?.answers[0] <= props?.sections?.value) {
    //     //   setSate(1);
    //     // }
    //     // else {
    //     //   setSate(2);
    //     // }

    //     // if (props?.sections?.answers[1] <= props?.sections?.value) {
    //     //   setSate(1);
    //     // }
    //     // else {
    //     //   setSate(2);
    //     // }

    //     // if (props?.sections?.answers[2] <= props?.sections?.value) {
    //     //   setSate(1);
    //     // }
    //     // else {
    //     //   setSate(2);
    //     // }

    //   }
    // }
    Abcd();
  }, [])

  const Abcd = () => {
    if (props?.sections?.isMax == false) {
      // for (let id = 0; id < props?.sections?.answers.length; id++) {}

      if (props?.sections?.answers[1] <= props?.sections?.value) {
        setSate(1);
      }
      else {
        setSate(2);
      }

    }
  }


  return (
    <div>
      <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" style={{ width: 'auto', padding: "10px" }} className="flex-container"  >
        <h5 className="card-title" style={{ fontSize: "17px", fontWeight: "bold", marginBottom: 10, color: "#667085" }}
        >{props?.sections?.questionName}
        </h5>
        <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085", height: "2px" }} />
        {props?.sections?.isMax != true ? (<>
          <h5 style={{ fontSize: "15px", color: "#101828", marginBottom: 20 }}><span sx={{ marginTop: 3 }}>{t('VendorDetails.label4')}</span><Chip hidden={props?.PQSTID == 4 || props?.PQSTID == 33 || props?.PQSTID == 32 || props?.PQSTID == 14 || props?.PQSTID == 10} label={(props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[0] == "") ? " N/A" : props?.sections?.answers[0]} style={{ backgroundColor: ((props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[0] == "") ? "#ffff00" : props?.sections?.isMax == false && props?.sections?.answers[0] <= props?.sections?.value ? '#EE3F3F' : '#12B76A'), borderRadius: "10px", color: "#000000", float: "right" }} /></h5>
          <h5 style={{ fontSize: "15px", color: "#101828", marginBottom: 20 }}><span sx={{ marginTop: 3 }}>{t('VendorDetails.label5')}</span><Chip hidden={props?.PQSTID == 4 || props?.PQSTID == 33 || props?.PQSTID == 32 || props?.PQSTID == 14 || props?.PQSTID == 10} label={(props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[1] == "") ? " N/A" : props?.sections?.answers[1]} style={{ backgroundColor: ((props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[1] == "") ? "#ffff00" : props?.sections?.isMax == false && props?.sections?.answers[1] <= props?.sections?.value ? '#EE3F3F' : '#12B76A'), borderRadius: "10px", color: "#000000", float: "right" }} /></h5>
          <h5 style={{ fontSize: "15px", color: "#101828", marginBottom: 10 }}><span sx={{ marginTop: 3 }}>{t('VendorDetails.label6')}</span><Chip hidden={props?.PQSTID == 4 || props?.PQSTID == 33 || props?.PQSTID == 32 || props?.PQSTID == 14 || props?.PQSTID == 10} label={(props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[2] == "") ? " N/A" : props?.sections?.answers[2]} style={{ backgroundColor: ((props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[2] == "") ? "#ffff00" : props?.sections?.isMax == false && props?.sections?.answers[2] <= props?.sections?.value ? '#EE3F3F' : '#12B76A'), borderRadius: "10px", color: "#000000", float: "right" }} /></h5>
        </>) : (<>
          <h5 style={{ fontSize: "15px", color: "#101828", marginBottom: 20 }}><span sx={{ marginTop: 3 }}>{t('VendorDetails.label4')}</span><Chip hidden={props?.PQSTID == 4 || props?.PQSTID == 33 || props?.PQSTID == 32 || props?.PQSTID == 14 || props?.PQSTID == 10} label={(props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[0] == "") ? " N/A" : props?.sections?.answers[0]} style={{ backgroundColor: ((props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[0] == "") ? "#ffff00" : props?.sections?.isMax == true && props?.sections?.answers[0] <= props?.sections?.value ? '#12B76A' : '#EE3F3F'), borderRadius: "10px", color: "#000000", float: "right" }} /></h5>
          <h5 style={{ fontSize: "15px", color: "#101828", marginBottom: 20 }}><span sx={{ marginTop: 3 }}>{t('VendorDetails.label5')}</span><Chip hidden={props?.PQSTID == 4 || props?.PQSTID == 33 || props?.PQSTID == 32 || props?.PQSTID == 14 || props?.PQSTID == 10} label={(props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[1] == "") ? " N/A" : props?.sections?.answers[1]} style={{ backgroundColor: ((props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[1] == "") ? "#ffff00" : props?.sections?.isMax == true && props?.sections?.answers[1] <= props?.sections?.value ? '#12B76A' : '#EE3F3F'), borderRadius: "10px", color: "#000000", float: "right" }} /></h5>
          <h5 style={{ fontSize: "15px", color: "#101828", marginBottom: 10 }}><span sx={{ marginTop: 3 }}>{t('VendorDetails.label6')}</span><Chip hidden={props?.PQSTID == 4 || props?.PQSTID == 33 || props?.PQSTID == 32 || props?.PQSTID == 14 || props?.PQSTID == 10} label={(props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[2] == "") ? " N/A" : props?.sections?.answers[2]} style={{ backgroundColor: ((props?.PQSTID == 3 || props?.PQSTID == 5 || props?.PQSTID == 7 || props?.PQSTID == 15 || props?.PQSTID == 16) || (props?.sections?.answers[2] == "") ? "#ffff00" : props?.sections?.isMax == true && props?.sections?.answers[2] <= props?.sections?.value ? '#12B76A' : '#EE3F3F'), borderRadius: "10px", color: "#000000", float: "right" }} /></h5>

        </>)}
      </Box>
    </div >
  )
}
